import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import ScrollToTop from "./router/ScrollToTop";
import { ThemeProvider } from "./hooks/ThemeProvider";
import SiteEngineeringOverlay from "./components/feature/SiteEngineeringOverlay";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ThemeProvider>
        <ScrollToTop />
        <AppRoutes />
        <SiteEngineeringOverlay />
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
